import { api } from './base';

export interface PlanListItem {
  documentNumber: string;
  documentTitle: string;
  projectId: string;
  documentType: 'ai_plan';
  planStatus: string;
  targetDocuments?: string[];
  tasks?: Array<{ id: string; description: string; status: string }>;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export const plansApi = {
  /**
   * List all AI plans for a project
   */
  list: async (projectId: string): Promise<PlanListItem[]> => {
    const response = await api.get(`/projects/${projectId}/documents`, {
      params: { documentType: 'ai_plan' }
    });
    return response.data.data as PlanListItem[];
  },

  /**
   * Get a single plan with full content
   */
  get: async (projectId: string, planId: string) => {
    const response = await api.get(`/projects/${projectId}/documents/${planId}`, {
      params: { includeContent: 'true', format: 'json' }
    });
    return response.data.data;
  },

  /**
   * Create a new AI plan
   */
  create: async (projectId: string, data: {
    documentNumber: string;
    documentTitle: string;
    targetDocuments?: string[];
  }): Promise<PlanListItem> => {
    const response = await api.post(`/projects/${projectId}/documents`, {
      ...data,
      documentType: 'ai_plan',
      planStatus: 'draft',
      tasks: [],
    });
    return response.data.data as PlanListItem;
  },

  /**
   * Update a plan (metadata, status, tasks)
   */
  update: async (projectId: string, planId: string, updates: {
    planStatus?: string;
    tasks?: Array<{ id: string; description: string; status: string; order: number }>;
    documentTitle?: string;
    targetDocuments?: string[];
  }) => {
    const response = await api.patch(`/projects/${projectId}/documents/${planId}`, updates);
    return response.data.data;
  },

  /**
   * Update plan status
   */
  updateStatus: async (projectId: string, planId: string, planStatus: string) => {
    const response = await api.patch(`/projects/${projectId}/documents/${planId}`, { planStatus });
    return response.data.data;
  },

  /**
   * Delete a plan
   */
  delete: async (projectId: string, planId: string) => {
    await api.delete(`/projects/${projectId}/documents/${planId}`);
  },
};
